/**
 * WebSocket close codes the learner actor uses on the live channel (4000-4999 is the
 * application range). Both mean the token in hand is no longer good: the client stops
 * reconnecting and asks for a new one (device credential plus PIN).
 */
export const LIVE_CLOSE = {
  /** The learner token (or voice session) reached its expiry. */
  tokenExpired: 4001,
  /** A parent revoked the device, reset the PIN or archived the profile. */
  revoked: 4003,
} as const;

/** Whether a close code means the session's credentials are no longer accepted. */
export function isAuthClose(code: number): boolean {
  return code === LIVE_CLOSE.tokenExpired || code === LIVE_CLOSE.revoked;
}
